import { reduceMotion } from '@js/animations/ReducedMotion'
import { createOnceOnEnter } from '@js/animations/scrollTriggerHelper'

export class Translate {
  constructor () {
    this._elements = document.querySelectorAll('[animation-translate]')

    if (!this._elements.length) {
      return
    }

    this.init()
  }

  init () {
    this._elements.forEach((el) => {
      const direction = el.getAttribute('animation-translate')

      if (reduceMotion) {
        el.classList.add('animation-translate-' + direction + '--active')
        return
      }

      createOnceOnEnter({
        trigger: el,
        start: 'top-=200 100%',
        onEnter: () => {
          el.classList.add('animation-translate-' + direction + '--active')
        },
      })
    })
  }
}
